<template>
    <div>
        <div id="panel" ref="collectionPanel" :style="styles">
            <collection-search
                :collections="collections?.data"
                v-model="filteredCollection"
                @filtered="useFiltered"
             />
            <button
                class="btn btn-link btn-add btn-primary border-primary w-100 d-flex align-items-center"
                @click="showCreate = true"
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    width="18"
                    height="18"
                    class="me-3"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 4.5v15m7.5-7.5h-15"
                    />
                </svg>
                <span>Collection</span>
            </button>
            <create-collection
                v-if="showCreate"
                @created="emit('refresh')"
                @closed="showCreate = false"
            ></create-collection>
            <ul class="mt-4 collection-list p-0">
                <li
                    v-for="collection in collectionsData?.data"
                    :key="collection.id"
                    @click="trigger(collection)"
                    class="d-flex justify-content-start align-items-center ps-4"
                    :class="collection.id == activeCollection ? 'bg-primary-subtle' : ''"
                >
                    <img :src="collection.image.url" width="32px" :alt="collection.name" class="img img-thumbnail">
                    <div class="d-flex flex-column p-3">
                        <span class="fw-semibold">{{ collection.name }}</span>
                        <span class="">{{ collection.description }}</span>
                    </div>
                </li>
            </ul>

        </div>
        <icon-list
            v-if="show"
            :styles="floatingStyles"
            ref="markers"
            :collection="collection"
            :marker="marker"
            @added="emit('refresh')"
            @closed="show = false"
        ></icon-list>
    </div>
</template>

<script setup>
    import {ref, inject, watch, reactive, nextTick} from 'vue';
    import {useFloating, autoPlacement, offset} from '@floating-ui/vue';
    import IconList from "./IconList.vue";
    import CreateCollection from './CreateCollection.vue';
    import CollectionSearch from './CollectionSearch.vue';

    const props = defineProps(["styles", "collections", "marker"]);
    const emit = defineEmits('refresh')

    const collectionPanel = ref(null);
    const markers = ref(null);
    const collection = reactive({data: {}});
    const collectionsData = reactive({data: []});
    const show = ref(false);
    const showCreate = ref(false)
    const filteredCollection = reactive({data: []});
    const activeCollection = ref(null)

    const state = inject('parentShow', ref(false));

    const {floatingStyles, update} = useFloating(collectionPanel, markers, {
        middleware: [offset(1), autoPlacement({
            alignment: 'right'
        })],

    });

    watch(state, () => show.value = state.value);
    watch(props, () => update());

    function trigger(coll) {
        show.value = false;
        collection.data = coll
        activeCollection.value = coll.id
        show.value = true;
    }

    nextTick(() => collectionsData.data = props?.collections.data)

    function useFiltered(data) {
        // on trigger this should update the list of collections used on the list
        // the list should then retain the original list of collections
        // but also be able to clear the search values
        collectionsData.data = data
    }

</script>

<style lang="scss" scoped>
#panel {
    width: 100%;
    max-width: 300px;
    position: absolute;
    top: 10px;
    left: 0px;
    background: white;
    color: #222222;
    // border-radius: 5px;
    font-size: 90%;
    padding: 6px;
    box-shadow: 4px 2px 9px 2px #0000001A;
}

.btn-add {
    border: 1px dashed;
}

.collection-list {
    list-style: none;
    max-height: 400px;
    overflow-y: scroll;
    li:last-child {
        margin-bottom: 2em;
    }
}
</style>
